module.exports = __webpack_public_path__ + "static/noise_2.44b8d271.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/navigation/noise_2.gif
// module id = 689
// module chunks = 213534597649335